const TOKEN_KEY = 'koolyum.deviceToken';
const FINGERPRINT_KEY = 'koolyum.deviceFingerprint';
const LAST_HASH_KEY = 'koolyum.lastManifestHash';

export function getDeviceToken(): string | null {
  return localStorage.getItem(TOKEN_KEY);
}

export function setDeviceToken(token: string): void {
  localStorage.setItem(TOKEN_KEY, token);
}

export function clearDeviceToken(): void {
  localStorage.removeItem(TOKEN_KEY);
}

export function getOrCreateDeviceFingerprint(): string {
  let fp = localStorage.getItem(FINGERPRINT_KEY);
  if (!fp) {
    fp = globalThis.crypto?.randomUUID?.()
      ?? `fp-${Date.now()}-${Math.random().toString(36).slice(2)}`;
    localStorage.setItem(FINGERPRINT_KEY, fp);
  }
  return fp;
}

export function getLastManifestHash(): string | null {
  return localStorage.getItem(LAST_HASH_KEY);
}

export function setLastManifestHash(hash: string): void {
  localStorage.setItem(LAST_HASH_KEY, hash);
}

export function clearLastManifestHash(): void {
  localStorage.removeItem(LAST_HASH_KEY);
}

// Redact for logs / debug overlay. Never show the full token.
export function redactToken(token: string | null): string {
  if (!token) return '(none)';
  if (token.length <= 12) return '****';
  return token.slice(0, 4) + '...' + token.slice(-4);
}
